import { User } from '../Model/User';
export class UsersService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async findOne(userId) {
        if (userId) {
            const response = await this.apiService.get('user/' + userId);
            if (!response.ok) {
                throw new Error(`Error al obtener los usuarios.`);
            }
            const content = await response.json();
            if (content) {
                const user = new User(content);
                return user;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener UserId.`);
        }
    }
    async queryUsers(queryString, offset, limit) {
        const params = new URLSearchParams();
        params.set('q', queryString);
        params.set('offset', `${offset}`);
        params.set('limit', `${limit}`);
        const response = await this.apiService.get(`users/query?${params}`);
        if (!response.ok) {
            throw new Error(`Error al consultar los usuarios.`);
        }
        const content = await response.json();
        return content.map((dto) => new User(dto));
    }
    async findUsers(offset, limit) {
        const response = await this.apiService.get(`users/${offset}/${limit}`);
        if (!response.ok) {
            throw new Error(`Error al obtener los usuarios.`);
        }
        const content = await response.json();
        return content.map(user => new User(user));
    }
    async saveUser(user) {
        const response = await this.apiService.post('user', user);
        if (!response.ok) {
            throw new Error(`Error al guardar el usuarios.`);
        }
    }
    async deleteUser(userId) {
        const response = await this.apiService.delete(`user/${userId}`);
        if (!response.ok) {
            throw new Error(`Ha ocurrido un error al eliminar el usuario.`);
        }
    }
}
